import React from 'react';
import { Modal } from 'antd';

const InformModal = ({ isOpen, onClose, content, type = 'inform' }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      closable={type !== 'inform'}
    >
      <p style={{ color: type === 'error' ? '#f5222d' : undefined }}>{content}</p>
    </Modal>
  );
};

export default InformModal;
